var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLunch = function SvgLunch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "lunch_svg__a",
    width: 24,
    height: 25,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 .188h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#lunch_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.375 20.187h4v-1.15l.55-.175q1.924-.6 3.263-1.925 1.337-1.325 1.837-2.75H3.775q.5 1.425 1.813 2.75t3.237 1.925l.55.175zm-.2 1a.77.77 0 0 1-.562-.238.77.77 0 0 1-.238-.562v-.65Q6.2 18.911 4.7 17.4t-2.025-3.387a.59.59 0 0 1 .1-.575.67.67 0 0 1 .55-.25H4V5.912q0-.3.213-.525a.9.9 0 0 1 .512-.275l16.05-1.75a.42.42 0 0 1 .35.112q.15.138.15.338 0 .15-.112.262a.5.5 0 0 1-.288.138L9.425 5.487v2.05h11.5a.44.44 0 0 1 .325.125.44.44 0 0 1 .125.325.4.4 0 0 1-.125.3.44.44 0 0 1-.325.125h-11.5v4.775H19.45q.375 0 .575.25a.59.59 0 0 1 .1.575q-.525 1.876-2.063 3.387-1.538 1.513-3.687 2.338v.625q0 .375-.225.6a.78.78 0 0 1-.575.225zM7.15 7.537h1.375v-1.95l-1.375.15zm-2.275 0h1.4V5.812l-1.4.15zm2.275 5.65h1.375V8.412H7.15zm-2.275 0h1.4V8.412h-1.4z"
  }))));
};
export default SvgLunch;